/*
 *
 * SmartAccuPay
 *
 * This class is the Language selection class and user can change language of the portal.
 * Language option is hide for SmartAccuPay. May be introduce in future.
 *
 * Created by SmartAccuPay.
 * Copyright © 2022 SmartAccuPay. All rights reserved.
 *
 */


import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateService } from '@ngx-translate/core';
import { localStorageConstants } from 'src/consts/local-storage-constants';
import { configData } from 'src/environments/configData';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
  imports: [NgClass, MatMenuModule]
})
export class LanguageComponent {

  selectlanguage: string;
  public colors: string[] = [
    'englishColor',
    'spanishColor',
  ];

  //Get Supported language data from configdata
  public languages_new: any[] = configData.LANGUAGE_ARRAY;

  /*
    Constructor
  */
  constructor(public translate: TranslateService) {
    const tmp_locallanguage = localStorage.getItem(localStorageConstants.LANGUAGE);
    const locallanguage = tmp_locallanguage == "" || tmp_locallanguage == undefined || tmp_locallanguage == null ? configData.INITIALLANGUAGE : tmp_locallanguage;
    this.selectlanguage = locallanguage;
  }

  // Here language changes and we store that in localstorage
  public changeLanguage(language_select: any) {
    localStorage.setItem(localStorageConstants.LANGUAGE, language_select);
    this.selectlanguage = language_select;
    this.translate.use(language_select);
  }
}
